import React, { Component } from 'react';
import isEmpty, {defaultDateFormat, formatAmount, parseDateWithFormat} from "../../utils/helpers";
import ProgressBar from "../../components/ProgressBar";
import ReactHtmlParser from "react-html-parser";
import FlyInRightPanel from "../../components/FlyInRightPanel";
import {OneTimePayment} from "../Home/OneTimePayment";
import AddEditPaymentMethods from "../Home/AddEditPaymentMethods";
import {DISTRIBUTION_METHOD_DESCRIPTION} from "../Home/CustomerServices";
import {
    getPrimaryContactName, getPrimaryContactCardName, getAddress, getAccountNumber, getStatus, getAccountTitleName, getPanelPayments, getPanelInvoices, getPanelMakePayments
} from '../../utils/LinkedAccountHelpers'

import { getLinkedAccountInfo, getMyCardAmounts,getMyAutoPayCardInfo  } from '../../actions/getLinkedAccountInfo';


import {connect} from 'react-redux';
import {
    createLoadingSelector, getUserPermission,
    selectHomeInfo, selectIsActive,
    selectLinkedAccounts,
    selectLinkedAccountsError,
    selectLinkedAccountsLoading
} from "../../selectors";
import {toggleIsActive, unlinkCurrentUserFromAccount} from '../../actions/linkedAccountsInfoActions'
import {toastr} from "react-redux-toastr";

import {
    getAccountDistributionMethod, getAccountTypeDistributionMethods,
    getAutoPayAvailableCC,
    getMyAmounts,
    getMyAutoPayInfo,
    getMyInvoices,
    getMyOrders,
    getMyServiceInfo
} from "../../actions/homeInfoActions";
import {getCurrentPaymentProviderSupportsPaymentMethodStorage} from "../../actions/paymentProviderActions";
import {getUserPermissions} from "../../actions/authActions";
import {fetchLinkedAccounts} from "../../actions/linkedAccountsInfoActions";
import {getAccountInfoById} from "../../actions/accountInfoActions";
import Payment from '../../containers/Home/Payment';
import Invoices from '../../containers/Home/Invoices';
import Payments from '../../containers/Home/Payments';
import PaymentMethods from '../Home/PaymentMethods'
import '../../CustomStyleSheet.css'
import PaymentComponent from "../Home/Payment/PaymentComponent";
import {setLoading, clearLoading} from "../../actions/loadingActions";
import OneTimePaymentComponent from "../Home/OneTimePayment/OneTimePaymentComponent";

const PANEL = {
    NONE: 0,
    INVOICES: 1,
    MANAGE_PLANS: 2,
    PAYMENT: 3,
    AUTOPAY: 4,
    PAPERLESS: 5,
    ORDERS: 6,
    PAYMENTS: 7,
    MANAGE_PAYMENTS: 8,
    ADD_EDIT_PAYMENT_METHODS: 9,
    ONE_TIME_PAYMENT: 10,
    LINK: 11
}


const callFunc = (func, ...args) => {
    if (typeof func === 'function') {
        func(...args);
    }
}

class LinkAccountCard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            accountInfo: null,
            amountBalance: null,
            dueOn: '',
            showManagePlanIndex: -1,
            activePanel: PANEL.NONE,
            visiblePanel: PANEL.NONE,
            resetFormOnClose: false,
            preventPanelClosing: false,
            payProviderSupportsPaymentMethodStorage: false,
            installmentPlans:[],
            autoPayInfo: [],
            accountBalanceFetchAttemptCount: 0,
            fetchBalanceTimer: null,
            isBalanceLoading: false,
            postPayment: null,
            previousBalance: null,
            fetchAttempts: 0,
            myAutoPay: {},
            paymentAmount: 1.00,
            panelLoading: false,
            amounts: null,
            // invoices : null,
            // amounts: null,

        };
    }

    componentWillUnmount() {
        clearInterval(this.fetchBalanceInterval);
    }

    async componentDidMount() {
        this.props.setTogglePanel(this.togglePanel);
        const { accountId } = this.props;
        this.setState({ isBalanceLoading: true });

        let Amounts, autoPayInfo;
        try {
            Amounts = await getMyCardAmounts(accountId);
            autoPayInfo = await getMyAutoPayCardInfo(accountId);
            this.setState({previousBalance: Amounts.amounts.accountBalace})

            this.setState({
                amountBalance: Amounts.amounts.accountBalace, // Using accountBalace
                dueOn: Amounts.amounts.dueDate || '',
                autoPayInfo: autoPayInfo,
                isBalanceLoading: false,
                postPayment: Amounts.amounts.postPaymentAmount || null,
                amounts: Amounts
            });

        } catch (err) {
            this.setState({ isBalanceLoading: false });
        }
    }

    startBalanceCheck = async () => {
        const { accountId } = this.props;
        this.setState({ isBalanceLoading: true });

        let Amounts, autoPayInfo;
        try {
            Amounts = await getMyCardAmounts(accountId);
            autoPayInfo = await getMyAutoPayCardInfo(accountId);
            this.setState({previousBalance: Amounts.amounts.accountBalace})

            this.setState({
                amountBalance: Amounts.amounts.accountBalace,
                dueOn: Amounts.amounts.dueDate || '',
                autoPayInfo: autoPayInfo,
                isBalanceLoading: false,
                postPayment: Amounts.amounts.postPaymentAmount || null,
                amounts: Amounts.amounts
            });

        } catch (err) {
            this.setState({ isBalanceLoading: false });
        }
    }


    fetchUpdatedBalanceWithCheck = () => {

        const { accountId } = this.props;
        const {amountBalance} = this.state
        const oldAccountbalance = amountBalance
        if (this.state.fetchAttempts < 7) {
            this.setState({ isBalanceLoading: true });
            getMyCardAmounts(accountId).then((rep) => {
                const newBalance = rep.amounts.accountBalace;
                if (newBalance !== oldAccountbalance) {
                    this.setState({ accountBalance: newBalance });
                    clearInterval(this.fetchBalanceInterval);
                    this.setState({ fetchAttempts: 0, isBalanceLoading: false });
                    this.startBalanceCheck()
                } else {
                    this.setState(prevState => ({
                        fetchAttempts: prevState.fetchAttempts + 1,
                        isBalanceLoading: false
                    }));
                }
            }).catch(error => {

                this.setState(prevState => ({
                    fetchAttempts: prevState.fetchAttempts + 1,
                    isBalanceLoading: false
                }));
            });
        } else {
            clearInterval(this.fetchBalanceInterval);
            this.setState({fetchAttempts: 0, isBalanceLoading: false})

        }
    }



    async componentDidMount() {
        this.props.setTogglePanel(this.togglePanel);
        const { accountId } = this.props;
        this.setState({ isBalanceLoading: true });
        let Amounts, autoPayInfo, accInvoices
        try {

            Amounts = await getMyCardAmounts(accountId);
            autoPayInfo = await getMyAutoPayCardInfo(accountId);
            // accInvoices = await this.props.getMyInvoices(accountId);

            this.setState({
                amountBalance: Amounts.amounts.accountBalace,
                dueOn: Amounts.amounts.dueDate || '',
                autoPayInfo: autoPayInfo,
                isBalanceLoading: false,
                postPayment: Amounts.amounts.postPaymentAmount || null,
                // invoices: accInvoices.invoices,
                // amounts: Amounts,
            });

        } catch (err) {
            this.setState({ isBalanceLoading: false });
        }

    }


    componentDidUpdate(prevProps) {
        if (this.props.myServiceInfo !== prevProps.myServiceInfo) {
        }
        if (this.props.myServiceInfoLoader !== prevProps.myServiceInfoLoader) {
        }
    }
    handleManage = () => {
        if(this.props.accountInformation && this.props.accountInformation.accountInfo) {
            this.props.handleManageClick(this.props.accountInformation.accountInfo.accountId, this.props.accountInformation.accountInfo.accountType)
        } else {
            this.props.handleManageClick(this.props.accountInformation.id, this.props.accountInformation.accountType.name)
        }
    }
    // handleUnlink = () => {
    //
    //
    //     toastr.confirm('Are you sure you want to Unlink this account?', {
    //         cancelText: 'Cancel',
    //         okText: 'Confirm',
    //         onOk: async () => {
    //             const accountId = this.props.accountInformation.accountInfo.accountId
    //             const unregisteredBySystemUserId = this.props.accountInformation.systemUserId;
    //             const userId = this.props.accountInformation.systemUserId;
    //
    //             try {
    //                 const response = await unlinkCurrentUserFromAccount(accountId, unregisteredBySystemUserId, userId);
    //                 window.location.reload()
    //             } catch (error) {
    //                 console.error(error);
    //             }
    //         }
    //     })
    //
    // }

    showPanel = (panel, getInitialSate) => {
        this.setState(prevState => {
                const additionalState = callFunc(getInitialSate, prevState);

                return { activePanel: panel, ...additionalState };
            },
            () => {
                clearTimeout(this.panelTimeoutHandler);
                this.panelTimeoutHandler = setTimeout(() => this.setState({ visiblePanel: panel }), 0)
            }
        );
    }

    hidePanel = (hideTimeoutMs, callback) => {
        this.setState({ visiblePanel: PANEL.NONE }, () => {
            callFunc(callback);
            clearTimeout(this.panelTimeoutHandler);
            this.panelTimeoutHandler = setTimeout(() => this.setState({ activePanel: PANEL.NONE }), hideTimeoutMs || 500);
        });
    }

    ;
    updateAccountInfo = async (accountId, accountTypeName) => {
        const {
            getMyServiceInfo,
            getMyOrders,
            getMyInvoices,
            getMyAmounts,
            getMyAutoPayInfo,
            getAutoPayAvailableCC,
            getAccountDistributionMethod,
            getAccountTypeDistributionMethods,
            getUserPermissions
        } = this.props;

        try {
            await Promise.all([
                getMyServiceInfo(accountId),
                getMyOrders(accountId),
                getMyInvoices(accountId),
                getMyAmounts(accountId),
                getMyAutoPayInfo(accountId),
                getAutoPayAvailableCC(accountId),
                getAccountDistributionMethod(accountId),
                getAccountTypeDistributionMethods(accountTypeName),
                getUserPermissions()
            ]);

            this.setState({ panelLoading: false });
        } catch (error) {
            console.error(error);
        }
    };

    togglePanel = (panel, newStateValueMap, hideTimeoutMs, getInitialSate, onHideCallback) => {
        this.props.setLoading()
        this.setState({panelLoading: true})
        if (newStateValueMap !== undefined) {
            this.setState(newStateValueMap);
        }

        if (this.state.activePanel === panel) {
            this.hidePanel(hideTimeoutMs, onHideCallback);
        } else {
            this.showPanel(panel, getInitialSate);
        }

        if (this.fetchBalanceInterval) {
            clearInterval(this.fetchBalanceInterval);
        }

        this.updateAccountInfo(this.props.accountId, this.props.accountType);
        this.setState({ resetFormOnClose: true }, () => {
            this.setState({ resetFormOnClose: false });
            this.setState({ fetchAttempts: 0 });
        });

        if (panel === PANEL.INVOICES || panel === PANEL.PAYMENT) {
            this.setState({ myInvoicesInfoLoader: true, myAmountsLoader: true });

            this.props.getMyInvoices(this.props.accountId).then(res => {

                this.setState({ myInvoices: res, myInvoicesInfoLoader: false });
            }).catch(() => {
                this.setState({ myInvoicesInfoLoader: false });
            });

            this.props.getMyAmounts(this.props.accountId).then(amounts => {
                this.setState({ myAmounts: amounts, myAmountsLoader: false });
                this.props.clearLoading()
            }).catch(() => {
                this.setState({ myAmountsLoader: false });
            });

            this.props.getMyAutoPayInfo(this.props.accountId).then(autoPay => {
                this.setState({ myAutoPay: autoPay});
            }).catch(() => {

            });
        }


    }

    togglePreventPanelClosing = (state) => {
        this.setState({preventPanelClosing: state});
    }

    dateconverter =(date)=>{
        const datearr=date.split('-');
        const monthlist={
            '01':'Jan',
            '02':'Feb',
            '03':'Mar',
            '04':'Apr',
            '05':'May',
            '06':'Jun',
            '07':'Jul',
            '08':'Aug',
            '09':'Sep',
            '10':'Oct',
            '11':'Nov',
            '12':'Dec'
        }

        return `${monthlist[datearr[1]]} ${datearr[2]}, ${datearr[0]}`
    }


    render() {

        const { preventPanelClosing, visiblePanel, resetFormOnClose, activePanel, autoPayInfo } = this.state
        const {
            accountInfo,
            myServiceInfo,
            myServiceInfoLoader,
            myOrders,
            myOrdersInfoLoader,
            myInvoices,
            myInvoicesInfoLoader,
            myAmounts,
            myAmountsLoader,
            myAutoPayInfo,
            myAutoPayAvailableCC,
            myDistributionMethods,
            myCurrentDistributionMethod,
            handleManageClick,
            accountInformation,
            primaryAcct,
            canPayNow,
            canViewPayments,
            canViewInvoices,
            canManagePaymentMethods
        } = this.props;

        const statusInfo = getStatus(accountInformation);


        return (
            <>
                <div className="card card-service " >
                    <div className='d-flex justify-content-between font-weight-bold ' style={{cursor: 'pointer'}} onClick={this.handleManage}>

                        <div className='px-4 d-flex flex-column text-secondary'>

                            <span className="linked-account-cards text-md">{getPrimaryContactCardName(accountInformation)} <i className="fa fa-external-link-alt"></i> </span>
                            <span className='text-muted text-sm ' style={{ fontWeight: '500' }}>{getAccountNumber(accountInformation)}</span>
                            <span className='text-muted text-sm ' style={{ fontWeight: '500' }}>  {getAddress(accountInformation)}</span>
                        </div>
                        <div className='px-4 text-md'>

                        <span
                            className={"badge  " + (
                                accountInformation.status && accountInformation.status === "Active" ? "badge-success":
                                    accountInformation.accountInfo && accountInformation.accountInfo.accountStatus && accountInformation.accountInfo.accountStatus === "Active" ? "badge-success":
                                        accountInformation.status && accountInformation.status === "Deactivated" ? "badge-danger":
                                            accountInformation.accountInfo && accountInformation.accountInfo.accountStatus && accountInformation.accountInfo.accountStatus === "Deactivated" ? "badge-danger":
                                                accountInformation.status && accountInformation.status === "Survey" ? "badge-outline-white" :
                                                    accountInformation.accountInfo && accountInformation.accountInfo.accountStatus && accountInformation.accountInfo.accountStatus === "Survey" ? "badge-outline-white":
                                                        accountInformation.status && accountInformation.status === "Prospect" ? "badge-outline-white" :
                                                            accountInformation.accountInfo && accountInformation.accountInfo.accountStatus && accountInformation.accountInfo.accountStatus === "Prospect" ? "badge-outline-white":
                                                                accountInformation.status && accountInformation.status === "Signup" ? "badge-white text-success" :
                                                                    accountInformation.accountInfo && accountInformation.accountInfo && accountInformation.accountInfo.accountStatus && accountInformation.accountInfo.accountStatus === "Signup" ? "badge-white text-success":
                                                                        accountInformation.status && accountInformation.status === "Suspended" ? "badge-warning" :
                                                                            accountInformation.accountInfo && accountInformation.accountInfo.accountStatus && accountInformation.accountInfo.accountStatus === "Suspended" ? "badge-warning":
                                                                                accountInformation.status && accountInformation.status === "Written-Off" ? "badge-white text-danger" :
                                                                                    accountInformation.accountInfo && accountInformation.accountInfo.accountStatus && accountInformation.accountInfo.accountStatus === "Written-Off" ? "badge-white text-danger":
                                                                                        "badge-customer-container-bg"
                            )}
                        >
                                {accountInformation.status ? accountInformation.status : accountInformation.accountInfo.accountStatus}
                            </span>

                        </div>


                    </div>
                    <hr/>


                    <div className="card-caption align-items-center justify-content-between">

                        <div className="card-left">

                            <div className="card-icon">
                                <i className="fas fa-wallet"/>
                            </div>

                        </div>
                        <div className="card-right">

                            <div className="card-header">

                                <div>
                                    Total Balance
                                    <p>
                                <span className='text-muted text-sm'>
                                    {autoPayInfo && (autoPayInfo.apiAccountAutoPayACH || autoPayInfo.apiAccountAutoPayCC || autoPayInfo.apiAccountAutoPayToken)
                                        ? <>
                                            <i className="fas fa-fw fa-dollar-sign text-success"/>
                                            {this.state.amountBalance > 0 ? `Autopay is enabled, and scheduled for ${this.dateconverter(autoPayInfo.appliesOn)}` : `Autopay is enabled`}
                                        </> : ''
                                    }
                                </span>
                                    </p>


                                </div>

                                <div className="d-flex flex-column align-items-start align-items-md-end">
                                    <span className="font-weight-bold float-right text-right">
                                        {this.state.isBalanceLoading ?
                                            <i className="fas fa-spinner fa-spin"/> : '$' + formatAmount(this.state.amountBalance)}
                                    </span>
                                    {this.state.postPayment &&
                                        <div style={{fontSize: '13px', color: '#00000080'}}>
                                            Payment of ${this.state.postPayment.toFixed(2)} is pending
                                        </div>
                                    }
                                    <span className="text-md">
                                        {this.state.amountBalance !== 0 && this.state.dueOn !== '' ?
                                            `Due on ${parseDateWithFormat(this.state.dueOn, defaultDateFormat)}` : ''}
                                    </span>
                                </div>

                            </div>

                        </div>
                    </div>

                    <div className="card-footer">

                        <div className="card-footer-toolbar">
                            {canViewPayments &&
                                <button className="btn btn-sm btn-fw-enable btn-light"
                                        onClick={() => this.togglePanel(PANEL.PAYMENTS)}>
                                    View Payments
                                </button>
                            }
                            {canViewInvoices &&
                                <button className="btn btn-sm btn-fw-enable btn-light"
                                        onClick={() => this.togglePanel(PANEL.INVOICES)}>
                                    View Invoices
                                </button>
                            }
                            {canPayNow &&
                                <button className="btn btn-sm btn-fw-enable btn-primary"
                                        onClick={() => this.togglePanel(PANEL.PAYMENT)}
                                >

                                    Make a Payment
                                </button>
                            }

                            {/*// </>*/}


                        </div>
                    </div>

                </div>
                <FlyInRightPanel
                    title={`Payment - ${getPrimaryContactCardName(accountInformation)}`}
                    isVissible={visiblePanel === PANEL.PAYMENT}
                    preventPanelClosing={preventPanelClosing}
                    onClose={async () => {
                        if (!preventPanelClosing) {
                            this.togglePanel(PANEL.PAYMENT);
                            this.setState({ resetFormOnClose: true }, () => {
                                this.setState({ resetFormOnClose: false, fetchAttempts: 0  }, () => {

                                    if (this.fetchBalanceInterval) {
                                        clearInterval(this.fetchBalanceInterval);
                                    }
                                    this.startBalanceCheck()
                                    this.fetchBalanceInterval = setInterval(this.fetchUpdatedBalanceWithCheck, 6000);
                                });
                            });
                            // await this.fetchBalanceAndUpdateState();
                            // if (this.state.postPayment) {
                            //     this.startBalanceCheck();
                            // }
                        }
                    }}
                >
                    {visiblePanel === PANEL.PAYMENT && (
                        <PaymentComponent
                            key={accountInformation && accountInformation.accountInfo ?  accountInformation.accountInfo.accountId : accountInformation.id}
                            accountId={accountInformation && accountInformation.accountInfo ?  accountInformation.accountInfo.accountId : accountInformation.id}
                            accountInfo={accountInformation}
                            myAutoPayInfo={this.state.myAutoPay}
                            // myAmountsLoader={this.state.isBalanceLoading}
                            isLoading={this.state.panelLoading}
                            // myAmounts={this.state.amounts}
                            accountBalance={this.state.amountBalance}
                            resetFormOnClose={resetFormOnClose}
                            togglePreventPanelClosing={this.togglePreventPanelClosing}
                            preventPanelClosing={preventPanelClosing}
                            togglePanel={this.togglePanel}
                        />
                    )}
                </FlyInRightPanel>

                {activePanel === PANEL.INVOICES &&
                    <FlyInRightPanel
                        title={`My Invoices - ${getPrimaryContactCardName(accountInformation)}`}
                        isVissible={visiblePanel === PANEL.INVOICES}
                        onClose={() => this.togglePanel(PANEL.INVOICES)}
                    >
                        <Invoices
                            myInvoicesInfoLoader={this.state.myInvoicesInfoLoader}
                            myInvoices={this.state.myInvoices}
                            myAmountsLoader={this.state.myAmountsLoader}
                            myAmounts={this.state.myAmounts}
                        />
                    </FlyInRightPanel>
                }

                {activePanel === PANEL.PAYMENTS &&
                    <FlyInRightPanel
                        title={`My Payments - ${getPrimaryContactCardName(accountInformation)}`}
                        isVissible={visiblePanel === PANEL.PAYMENTS}
                        onClose={() => {
                            this.togglePanel(PANEL.PAYMENTS);
                            this.setState({ resetFormOnClose: true }, () => {
                                this.setState({ resetFormOnClose: false });
                            })
                        }}
                    >

                        <Payments
                            accountInfo={getPanelPayments(accountInformation)}
                            postPaymentAmount={this.state.postPayment}
                        />
                    </FlyInRightPanel>
                }

                {activePanel === PANEL.MANAGE_PAYMENTS &&
                    <FlyInRightPanel
                        title={`Payment Methods - ${getPrimaryContactCardName(accountInformation)}`}
                        isVissible={visiblePanel === PANEL.MANAGE_PAYMENTS}
                        onClose={() => {
                            this.togglePanel(PANEL.MANAGE_PAYMENTS);
                            this.setState({resetFormOnClose: true}, () => {
                                this.setState({resetFormOnClose: false});
                            })
                        }}
                    >
                        <PaymentMethods
                            accountInfo={getPanelPayments(accountInformation)}
                            togglePanel={this.togglePanel}
                        />
                    </FlyInRightPanel>
                }

                {activePanel === PANEL.ONE_TIME_PAYMENT &&
                    <FlyInRightPanel
                        title={`One Time Payment - ${getPrimaryContactCardName(accountInformation)}`}
                        isVissible={visiblePanel === PANEL.ONE_TIME_PAYMENT}
                        onClose={() => {
                            this.togglePanel(PANEL.ONE_TIME_PAYMENT);
                            this.setState({resetFormOnClose: true}, () => {
                                this.setState({resetFormOnClose: false});
                                if (this.fetchBalanceInterval) {
                                    clearInterval(this.fetchBalanceInterval);
                                }
                                this.startBalanceCheck()
                                this.fetchBalanceInterval = setInterval(this.fetchUpdatedBalanceWithCheck, 6000);
                            })
                        }}
                    >
                        <OneTimePaymentComponent
                            key={accountInformation && accountInformation.accountInfo ?  accountInformation.accountInfo.accountId : accountInformation.id}
                            accountInfo={getPanelPayments(accountInformation)}
                            accountId={accountInformation && accountInformation.accountInfo ?  accountInformation.accountInfo.accountId : accountInformation.id}
                            togglePanel={this.togglePanel}
                            paymentAmount={this.state.paymentAmount}
                        />
                    </FlyInRightPanel>
                }

                {activePanel === PANEL.ADD_EDIT_PAYMENT_METHODS &&
                    <FlyInRightPanel
                        title={`Manage Payment Methods - ${getPrimaryContactCardName(accountInformation)}`}
                        isVissible={visiblePanel === PANEL.ADD_EDIT_PAYMENT_METHODS}
                        onClose={() => {
                            this.togglePanel(PANEL.ADD_EDIT_PAYMENT_METHODS);
                            this.setState({resetFormOnClose: true}, () => {
                                this.setState({resetFormOnClose: false});
                            })
                        }}
                    >
                        <AddEditPaymentMethods
                            accountInfo={getPanelPayments(accountInformation)}
                            togglePanel={this.togglePanel}
                        />
                    </FlyInRightPanel>
                }
                {activePanel === PANEL.LINK &&
                    <FlyInRightPanel
                        title="Link Account"
                        isVissible={visiblePanel === PANEL.LINK}
                        onClose={() => {
                            this.togglePanel(PANEL.LINK);
                            this.setState({ resetFormOnClose: true }, () => {
                                this.setState({ resetFormOnClose: false });
                            })
                        }}
                    >
                        Test
                    </FlyInRightPanel>
                }

            </>
        );
    };
}

const getMyServiceInfoLoader = createLoadingSelector(['MY_SERVICE']);
const getMyOrdersInfoLoader = createLoadingSelector(['MY_ORDERS']);
const getMyInvoicesInfoLoader = createLoadingSelector(['MY_INVOICES']);
const getMyAmountsLoader = createLoadingSelector(['MY_AMOUNTS']);

const mapStateToProps = (state) => {



    const
        myServiceInfo = selectHomeInfo(state).myServiceInfo,
        myServiceInfoLoader = getMyServiceInfoLoader(state),
        myOrders = selectHomeInfo(state).myOrders,
        myOrdersInfoLoader = getMyOrdersInfoLoader(state),
        myInvoices = selectHomeInfo(state).myInvoices,
        myInvoicesInfoLoader = getMyInvoicesInfoLoader(state),
        myAmounts = selectHomeInfo(state).myAmounts,
        myAmountsLoader = getMyAmountsLoader(state),
        myAutoPayInfo = selectHomeInfo(state).myAutoPayInfo,
        myAutoPayAvailableCC = selectHomeInfo(state).myAutoPayAvailableCC,
        myDistributionMethods = selectHomeInfo(state).myDistributionMethods,
        myCurrentDistributionMethod = selectHomeInfo(state).myCurrentDistributionMethod,
        linkedAccounts = selectLinkedAccounts(state),
        error =selectLinkedAccountsError(state),
        canPayNow = getUserPermission(state, "BILLING", "BILLING_PAY_NOW"),
        canViewPayments = getUserPermission(state, "BILLING", "BILLING_PAYMENTS_VIEW"),
        canViewInvoices = getUserPermission(state, "BILLING", "BILLING_INVOICES_VIEW"),
        canManagePaymentMethods = getUserPermission(state, "API", "API_MANAGE_PAYMENT_METHODS");



    return {
        myServiceInfo,
        myServiceInfoLoader,
        myOrders,
        myOrdersInfoLoader,
        myInvoices,
        myInvoicesInfoLoader,
        myAmounts,
        myAmountsLoader,
        myAutoPayInfo,
        myAutoPayAvailableCC,
        myDistributionMethods,
        myCurrentDistributionMethod,
        linkedAccounts,
        error,
        canPayNow,
        canViewPayments,
        canViewInvoices,
        canManagePaymentMethods
    }
};

const mapDispatchToProps = {
    getMyServiceInfo,
    getMyOrders,
    getMyInvoices,
    getMyAmounts,
    getMyAutoPayInfo,
    getAutoPayAvailableCC,
    getAccountDistributionMethod,
    getAccountTypeDistributionMethods,
    getCurrentPaymentProviderSupportsPaymentMethodStorage,
    getUserPermissions,
    fetchLinkedAccounts,
    getAccountInfoById,
    toggleIsActive,
    setLoading,
    clearLoading


};


export default connect(mapStateToProps, mapDispatchToProps)(LinkAccountCard);